import { render, staticRenderFns } from "./HotSalesList.vue?vue&type=template&id=e92b4a7c&scoped=true&"
import script from "./HotSalesList.vue?vue&type=script&lang=js&"
export * from "./HotSalesList.vue?vue&type=script&lang=js&"
import style0 from "./HotSalesList.vue?vue&type=style&index=0&id=e92b4a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92b4a7c",
  null
  
)

export default component.exports